import React, { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch } from "react-redux";

// Services

import { handleResetFormSteps, cleanUpClienteDataParcial } from '../../store/forms/forms.actions';

// Components

import Button from "../../components/UI/Button/Button";

// Styles

import "./Styles.scss";

export default function UserIsRegistered() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (state?.userPartialData?.is_completed) {
      dispatch(handleResetFormSteps());
      dispatch(cleanUpClienteDataParcial());

      localStorage.removeItem("clientEmail");
      localStorage.removeItem('clientPhone');
    } else {
      navigate(`/`);
    }
  }, []);

  return (
    <div className="page-wrapper">
      <div className="container">

        <div className="onboarding-page">
          <div className="onboarding-wrapper">

            <p>
              Usted ya es cliente Bancaribe, debe iniciar sesión en el siguiente link <br/>con su usuario y clave de conexión: <Link to={'/'}><strong>Iniciar sesión</strong></Link>.
            </p>
          </div>

          <Button
            type="button"
            action={() => navigate('/')}
            label={"Continuar"}
          />

        </div>

      </div>
    </div>
  );
}
